export const replaceGoToBaseUrl = (url) => {
  if (!url) {
    return url;
  }

  const baseUrl = process.env.REACT_APP_FR_ALB_HOSTNAME;

  if (url.startsWith(baseUrl)) {
    return `${process.env.REACT_APP_BASE_URL}${url.slice(baseUrl.length)}`;
  }

  return url;
};